(() => {
  if (window.cycoSmartDrawerLoaded) return;
  window.cycoSmartDrawerLoaded = true;
  const script = document.querySelector('[data-cyco-drawer-script]');
  const previewId = script?.dataset.previewThemeId;
  const root = window.Shopify?.routes?.root || '/';
  const sectionId = 'cyco-drawer-smart';
  let timer, lastKey = '', request = 0, busy = false, discountBusy = false, latestSource;
  const linkCard = card => {
    const handle = card.dataset.cycoProduct;
    if (!handle) return;
    const variant = card.querySelector('[data-cyco-drawer-select], [data-cyco-select]')?.value || card.querySelector('[data-cyco-drawer-add]')?.dataset.cycoDrawerAdd || card.querySelector('[data-cyco-add]')?.dataset.cycoAdd;
    const href = root + 'products/' + encodeURIComponent(handle) + (variant ? '?variant=' + encodeURIComponent(variant) : '');
    for (const element of card.querySelectorAll('h3, img')) {
      let link = element.closest('a');
      if (!link) { link = document.createElement('a'); element.before(link); link.append(element); }
      link.href = href;
      link.classList.add('cyco-cart-card__product-link');
    }
  };
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const drawer = () => document.querySelector('.Vtl-CartDrawer[aria-hidden="false"]');
  const key = node => JSON.stringify([
    [...node.querySelectorAll('.Vtl-CartDrawerProduct')].map(product => [
      product.querySelector('a')?.href,
      product.querySelector('.Vtl-CartDrawerProduct__Details-Top-Variants')?.textContent,
      product.querySelector('.Vtl-CartDrawerProduct__Details-Bottom-Prices')?.textContent
    ]),
    [...node.querySelectorAll('.Vtl-CartDrawerProducts input')].map(input => input.value),
    node.querySelector('.Vtl-CartDrawerCheckout')?.textContent
  ]);
  const endpoint = () => {
    const url = new URL(`${root}cart`, location.origin);
    url.searchParams.set('sections', sectionId);
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    return url;
  };
  const read = async () => {
    const response = await fetch(endpoint(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('refresh');
    const data = await response.json();
    const page = parse(data[sectionId] || '');
    const source = page.querySelector('[data-cyco-drawer-data]');
    if (!source) throw new Error('refresh');
    return source;
  };
  const choose = (source, drawerNode = null) => {
    // Our gift-box card is allowed alongside a verified matching clasp.
    const picks = [];
    const seen = new Set();
    // Prioritise a compatible clasp, then a matching item, then gift packaging.
    for (const kind of ['clasp', 'gift_box', 'small_box', 'chain_necklace', 'watch_bracelet', 'velorosa', 'rider_keyring', 'easy_extra']) {
      for (const card of source.querySelectorAll(`.cyco-cart-extras [data-cyco-kind="${kind}"]`)) {
        const product = card.dataset.cycoProduct || kind;
        if (!seen.has(product)) { picks.push(card); seen.add(product); }
        if (picks.length === 2) return picks;
      }
    }
    return picks;
  };
  const message = (node, text) => {
    const status = node?.querySelector('[data-cyco-drawer-status]');
    if (status) { status.textContent = text; status.hidden = !text; }
  };
  const labelProducts = (node, source) => {
    const products = node.querySelector('.Vtl-CartDrawerProducts');
    if (!products) return;
    const exclusions = source.querySelector('[data-cyco-drawer-excluded]')?.content;
    products.querySelectorAll('.Vtl-CartDrawerProduct').forEach(product => {
      const anchor = product.querySelector('a[href*="/products/"]');
      const handle = anchor ? new URL(anchor.href).pathname.split('/products/')[1]?.split('/')[0] : '';
      const excluded = [...(exclusions?.querySelectorAll('[data-product-handle]') || [])].find(item => item.dataset.productHandle === handle);
      const old = product.querySelector('[data-cyco-item-excluded]');
      if (excluded && !old) {
        const label = document.createElement('p');
        label.dataset.cycoItemExcluded = '';
        label.textContent = excluded.textContent;
        product.querySelector('.Vtl-CartDrawerProduct__Details-Top')?.append(label);
      } else if (!excluded && old) old.remove();
    });
  };
  const labelLinkedClasps = async node => {
    try {
      const response = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store'});
      if (!response.ok || !node.isConnected || node !== drawer()) return;
      const cart = await response.json();
      const products = node.querySelector('.Vtl-CartDrawerProducts');
      if (!products) return;
      const rows = [...products.querySelectorAll('.Vtl-CartDrawerProduct')];
      const displayRows = [...rows];
      let hasLinkedClasp = false;
      const mainLines = [...document.querySelectorAll('.cart-item-container[data-cyco-line-key]')];
      const isClasp = item => /extension-clasp/.test(item.handle || '');
      const rowFor = item => {
        const found = rows.filter(row => new URL(row.querySelector('a[href*="/products/"]')?.href || location.href).searchParams.get('variant') === String(item.variant_id));
        return found.length === 1 ? found[0] : null;
      };
      for (const item of cart.items.filter(isClasp)) {
        const line = mainLines.find(line => line.dataset.cycoLineKey === item.key);
        const parentKey = line?.dataset.cycoParentKey || item.properties?._cyco_cart_parent_key || item.parent_relationship?.parent?.key;
        const parentId = line?.dataset.cycoParentVariantId || item.properties?._cyco_parent_variant_id;
        let parent = cart.items.find(candidate => candidate.key === parentKey && !isClasp(candidate));
        if (!parent && parentId) {
          const found = cart.items.filter(candidate => String(candidate.variant_id) === String(parentId) && !isClasp(candidate));
          if (found.length === 1) parent = found[0];
        }
        if (!parent) {
          const width = (item.variant_title || item.title || '').match(/(?:^|[^0-9])(7|10|16)\s*mm\b/i)?.[1];
          const found = width ? cart.items.filter(candidate => !isClasp(candidate) && /bracelet/i.test(candidate.product_title || '') && new RegExp('(?:^|[^0-9])' + width + '\\s*mm\\b','i').test(candidate.product_title || '')) : [];
          if (found.length === 1) parent = found[0];
        }
        if (!parent) continue;
        const row = rowFor(item), parentRow = rowFor(parent);
        if (!row || !parentRow || row === parentRow) continue;
        row.classList.add('cyco-drawer-linked-clasp');
        row.dataset.cycoLinkedParent = parent.key;
        let label = row.querySelector('.cyco-drawer-linked-clasp__label');
        if (!label) { label = document.createElement('p'); label.className = 'cyco-drawer-linked-clasp__label'; row.querySelector('.Vtl-CartDrawerProduct__Details-Top')?.prepend(label); }
        const text = '↳ Extension clasp for ' + parent.product_title;
        if (label.textContent !== text) label.textContent = text;
        // Keep Vitals' native DOM ownership intact during discount and quantity refreshes.
        // Reorder the visual list only; moving a row between its groups breaks reconciliation.
        hasLinkedClasp = true;
        displayRows.splice(displayRows.indexOf(row), 1);
        displayRows.splice(displayRows.indexOf(parentRow) + 1, 0, row);
      }
      const groups = [...products.children];
      const plainGroups = groups.every(group => group.matches('.Vtl-CartDrawerProducts__Group') &&
        [...group.children].every(child => child.matches('.Vtl-CartDrawerProduct')));
      products.classList.toggle('cyco-drawer-clasp-order', hasLinkedClasp && plainGroups);
      const orderedGroups = [];
      displayRows.forEach((row, index) => {
        row.style.order = hasLinkedClasp ? String(index) : '';
        const group = row.closest('.Vtl-CartDrawerProducts__Group');
        if (group && !orderedGroups.includes(group)) orderedGroups.push(group);
      });
      orderedGroups.forEach((group, index) => {
        group.style.order = hasLinkedClasp && !plainGroups ? String(index) : '';
      });
    } catch {}
  };
  const render = (node, source) => {
    const products = node.querySelector('.Vtl-CartDrawerProducts');
    if (!products) return;
    latestSource = source;
    labelProducts(node, source);
    let progress = node.querySelector('[data-cyco-drawer-offer]');
    if (!progress) {
      progress = document.createElement('div');
      progress.dataset.cycoDrawerOffer = '';
      products.before(progress);
    }
    progress.innerHTML = source.querySelector('[data-cyco-drawer-progress]').innerHTML;
    const code = progress.querySelector('.cyco-cart-offer__code');
    if (code) {
      if (code.getAttribute('href')?.includes('/discount/')) {
        const hint = document.createElement('span');
        hint.className = 'cyco-drawer-code';
        hint.textContent = code.textContent;
        code.replaceWith(hint);
      } else code.remove();
    }
    let slot = node.querySelector('[data-cyco-drawer-slot]');
    if (!slot) {
      slot = document.createElement('div');
      slot.dataset.cycoDrawerSlot = '';
      products.after(slot);
    }
    const priorScroll = node.scrollTop;
    slot.replaceChildren();
    const cards = choose(source, node);
    const extras = [...source.querySelectorAll('.cyco-cart-extras [data-cyco-card]')];
    const allCards = [...cards];
    for (const card of extras) if (!allCards.some(item => item.dataset.cycoParentKey === card.dataset.cycoParentKey && item.dataset.cycoKind === card.dataset.cycoKind)) allCards.push(card);
    const applyMatchingSize = card => {
      if (card.dataset.cycoKind === 'clasp') return;
      const select = card.querySelector('[data-cyco-drawer-select]');
      if (!select) return;
      const cardName = (card.querySelector('h3')?.textContent || '').toLowerCase();
      const width = cardName.match(/(7|10|16)\s*mm/);
      if (!width) return;
      const matching = [...products.querySelectorAll('.Vtl-CartDrawerProduct')].find(row => {
        const text = row.textContent.toLowerCase();
        const href = row.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
        return /bracelet/i.test(href) && !/clasp|extension/i.test(href) && text.includes(width[1]+'mm') && /\d+(?:\.\d+)?\s*cm/.test(text);
      });
      const size = matching?.textContent.match(/\b(\d+(?:\.\d+)?)\s*cm\b/i)?.[1];
      if (!size) return;
      const option = [...select.options].find(opt => new RegExp('(^|[^0-9])'+size.replace('.','\\.')+'\\s*cm\\b','i').test(opt.textContent));
      if (!option) return;
      select.value = option.value;
      const button = card.querySelector('[data-cyco-drawer-add]');
      if (button) { button.dataset.cycoDrawerAdd = option.value; button.disabled = false; }
      const price = card.querySelector('.cyco-cart-card__price');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const image = card.querySelector('img');
      if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    };
    const recommendations = document.createElement('div');
    recommendations.className = 'cyco-drawer-recommendations';
    if (allCards.length > 2) {
      recommendations.classList.add('cyco-drawer-recommendations--carousel');
      if (matchMedia('(max-width:767px)').matches) {
        for (const [name, value] of Object.entries({display:'grid','grid-auto-flow':'column','grid-auto-columns':'minmax(145px,47%)','grid-template-columns':'none','overflow-x':'auto','overflow-y':'hidden','scroll-snap-type':'x mandatory','max-width':'100%','width':'100%'})) recommendations.style.setProperty(name,value,'important');
      }
    }
    for (const card of allCards) {
      const copy = card.cloneNode(true);
      copy.querySelectorAll('[data-cyco-add]').forEach(button => {
        button.dataset.cycoDrawerAdd = button.dataset.cycoAdd;
        button.removeAttribute('data-cyco-add');
      });
      copy.querySelectorAll('[data-cyco-select]').forEach(select => {
        select.dataset.cycoDrawerSelect = '';
        select.removeAttribute('data-cyco-select');
      });
      if (allCards.length > 2 && matchMedia('(max-width:767px)').matches) { copy.style.setProperty('width','100%','important'); copy.style.setProperty('min-width','0','important'); copy.style.setProperty('max-width','none','important'); copy.style.setProperty('scroll-snap-align','start'); }
      applyMatchingSize(copy);
      linkCard(copy);
      recommendations.append(copy);
    }
    if (allCards.length) {
      const heading = document.createElement('h3');
      heading.className = 'cyco-drawer-recommendations__heading';
      heading.textContent = 'Complete your ride';
      slot.append(heading, recommendations);
    }
    const relatedCards = [...source.querySelectorAll('.cyco-cart-picks [data-cyco-card]')].filter(card => !allCards.some(selected => selected.dataset.cycoProduct === card.dataset.cycoProduct)).slice(0, 6);
    if (relatedCards.length) {
      const relatedHeading = document.createElement('h3');
      relatedHeading.className = 'cyco-drawer-related__heading';
      relatedHeading.textContent = 'You might also like';
      const hint = document.createElement('span');
      hint.className = 'cyco-drawer-related__hint';
      hint.textContent = 'Swipe to explore →';
      const relatedTrack = document.createElement('div');
      relatedTrack.className = 'cyco-drawer-related';
      relatedTrack.setAttribute('role', 'region');
      relatedTrack.setAttribute('aria-label', 'Recommended products');
      relatedTrack.tabIndex = 0;
      for (const card of relatedCards) {
        const copy = card.cloneNode(true);
        copy.querySelectorAll('[data-cyco-add]').forEach(button => {
          button.dataset.cycoDrawerAdd = button.dataset.cycoAdd;
          button.removeAttribute('data-cyco-add');
        });
        copy.querySelectorAll('[data-cyco-select]').forEach(select => {
          select.dataset.cycoDrawerSelect = '';
          select.removeAttribute('data-cyco-select');
        });
        applyMatchingSize(copy);
      linkCard(copy);
        relatedTrack.append(copy);
      }
      slot.append(relatedHeading, hint, relatedTrack);
    }
    const status = document.createElement('p');
    status.dataset.cycoDrawerStatus = '';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    slot.append(status);
    const trust = document.createElement('p');
    trust.className = 'cyco-drawer-trust';
    trust.textContent = 'Secure checkout · Your order is protected';
    slot.append(trust);
    slot.dataset.adding = source.dataset.adding;
    slot.dataset.error = source.dataset.error;
    slot.dataset.success = source.dataset.success;
    slot.dataset.stale = source.dataset.stale;
    if (node.scrollTop !== priorScroll) node.scrollTop = priorScroll;
    node.classList.add('cyco-drawer-enhanced');
    labelLinkedClasps(node);
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const node = drawer();
      if (!node || busy || discountBusy) return;
      if (node.querySelector('.Vtl-CartDrawerProducts[aria-busy="true"]')) {
        lastKey = '';
        node.querySelector('[data-cyco-drawer-slot]')?.setAttribute('hidden', '');
        node.querySelector('[data-cyco-drawer-offer]')?.setAttribute('hidden', '');
        return;
      }
      const currentKey = key(node);
      if (currentKey === lastKey && node.querySelector('[data-cyco-drawer-slot]')) {
        if (latestSource) labelProducts(node, latestSource);
        labelLinkedClasps(node);
        return;
      }
      const id = ++request;
      try {
        const source = await read();
        if (id !== request || !node.isConnected || node !== drawer()) return;
        if (key(node) !== currentKey) { schedule(); return; }
        render(node, source);
        lastKey = currentKey;
        node.querySelector('[data-cyco-drawer-slot]')?.removeAttribute('hidden');
        node.querySelector('[data-cyco-drawer-offer]')?.removeAttribute('hidden');
      } catch {
        if (id === request) node.classList.remove('cyco-drawer-enhanced');
      }
    }, 160);
  };
  document.addEventListener('change', event => {
    const select = event.target.closest?.('[data-cyco-drawer-select]');
    if (!select) return;
    const card = select.closest('[data-cyco-card]');
    const button = card.querySelector('[data-cyco-drawer-add]');
    const option = select.selectedOptions[0];
    if (!button || !option) return;
    button.dataset.cycoDrawerAdd = select.value;
    button.disabled = !select.value;
    const label = card.querySelector('.cyco-cart-card__variant');
    if (label && !card.querySelector('[data-cyco-drawer-select]')) label.textContent = option.dataset.variantTitle || option.textContent;
    if (option.dataset.price) card.querySelector('.cyco-cart-card__price').textContent = option.dataset.price;
    linkCard(card);
    if (option.dataset.image) {
      const image = card.querySelector('img');
      if (image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-cyco-drawer-add]');
    if (!button) return;
    event.preventDefault();
    if (busy || discountBusy || button.disabled || !button.dataset.cycoDrawerAdd) return;
    const node = button.closest('.Vtl-CartDrawer');
    if (node.querySelector('.Vtl-CartDrawerProducts[aria-busy="true"]')) return;
    const slot = button.closest('[data-cyco-drawer-slot]');
    const card = button.closest('[data-cyco-card]');
    const variant = button.dataset.cycoDrawerAdd;
    busy = true;
    ++request;
    const controls = [...node.querySelectorAll('button:not([aria-label="Close Cart Drawer"]), input, select')];
    const disabled = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    slot.setAttribute('aria-busy', 'true');
    message(node, slot.dataset.adding);
    let added = false;
    try {
      const source = await read();
      const fresh = [...source.querySelectorAll('[data-cyco-card]')].find(item => item.dataset.cycoProduct === card.dataset.cycoProduct &&
        item.dataset.cycoKind === card.dataset.cycoKind && item.dataset.cycoParentKey === card.dataset.cycoParentKey);
      const valid = fresh && [...fresh.querySelectorAll('[data-cyco-add], option')].some(option => (option.dataset.cycoAdd || option.value) === variant);
      if (!valid) {
        render(node, source);
        message(node, slot.dataset.stale);
        return;
      }
      const parentCart = card.dataset.cycoKind === 'clasp' ? await (await fetch(`${root}cart.js`, {credentials:'same-origin'})).json() : null;
      const parentVariantId = parentCart?.items.find(item => item.key === card.dataset.cycoParentKey)?.variant_id;
      if (card.dataset.cycoKind === 'clasp' && !parentVariantId) throw new Error(slot.dataset.stale);
      const mainId = document.querySelector('[data-section-type="cart"]')?.dataset.sectionId;
      const sections = mainId ? [sectionId, mainId] : [sectionId];
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variant), quantity: 1, properties: { _cyco_addon_rule: card.dataset.cycoKind, _cyco_addon_source: 'drawer', ...(card.dataset.cycoKind === 'clasp' && card.dataset.cycoParentKey ? { _cyco_cart_parent_key: card.dataset.cycoParentKey, _cyco_parent_variant_id: String(parentVariantId || '') } : {}) } }],
          sections, sections_url: `${root}cart${previewId ? `?preview_theme_id=${previewId}` : ''}`
        })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || slot.dataset.error);
      added = true;
      if (mainId && data.sections?.[mainId]) {
        const page = parse(data.sections[mainId]);
        const current = document.querySelector('[data-section-type="cart"]');
        for (const selector of ['.cart-items', '.subtotal-row', '[data-cyco-offer-slot]', '[data-cyco-extras-slot]', '.cart-finish']) {
          const old = current?.querySelector(selector), next = page.querySelector(selector);
          if (old && next) old.innerHTML = next.innerHTML;
        }
      }
      const after = parse(data.sections?.[sectionId] || '').querySelector('[data-cyco-drawer-data]') || await read();
      render(node, after);
      message(node, slot.dataset.success);
      document.dispatchEvent(new CustomEvent('vitals:cart-drawer:syncRequested'));
    } catch (error) {
      if (added) {
        slot.querySelector('[data-cyco-card]')?.remove();
        message(node, slot.dataset.success);
        document.dispatchEvent(new CustomEvent('vitals:cart-drawer:syncRequested'));
      } else message(node, error.message === 'refresh' ? slot.dataset.error : error.message);
    } finally {
      busy = false;
      controls.forEach((control, i) => { if (control.isConnected) control.disabled = disabled[i]; });
      slot.removeAttribute('aria-busy');
      lastKey = '';
      schedule();
    }
  });
  for (const type of ['vitals:cart-drawer:opened', 'vitals:CartUpdated', 'vitals:CartUpdateFinish', 'cyco:cart-addon-added']) {
    document.addEventListener(type, schedule);
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-cyco-apply-b2gof]');
    if (!button) return;
    event.preventDefault();
    if (busy || discountBusy || button.disabled) return;
    // Do not replace an existing Vitals or other promotion from our enhancement layer.
    // Customers can still use the native checkout discount field if they choose.
    const existingDiscountResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' }).catch(() => null);
    if (!existingDiscountResponse?.ok) return;
    const existingCart = await existingDiscountResponse.json().catch(() => null);
    if (!existingCart) return;
    const hasOtherDiscount = (existingCart.discount_codes || []).some(code => code.applicable && code.code?.toUpperCase() !== 'B2GOF') || (existingCart.cart_level_discount_applications || []).some(d => (d.title || '').toUpperCase() !== 'B2GOF') || (existingCart.items || []).some(item => (item.discounts || []).some(d => (d.title || '').toUpperCase() !== 'B2GOF'));
    if (hasOtherDiscount) {
      const status = button.closest('.cyco-cart-offer')?.querySelector('[data-cyco-offer-status]');
      if (status) { status.textContent = 'Your existing offer is being kept. Other discounts may not combine with B2GOF.'; status.hidden = false; }
      return;
    }
    const openDrawer = drawer();
    if (openDrawer?.querySelector('.Vtl-CartDrawerProducts[aria-busy="true"]')) return;
    if ([...document.querySelectorAll('.quantity__number')].some(input => input.value !== input.dataset.initialValue)) return;
    discountBusy = true;
    ++request;
    const oldLabel = button.textContent;
    const offer = button.closest('.cyco-cart-offer');
    const report = text => {
      const status = offer?.querySelector('[data-cyco-offer-status]');
      if (status?.isConnected) { status.textContent = text; status.hidden = !text; }
    };
    const controls = [...document.querySelectorAll('[data-cyco-apply-b2gof], [data-cyco-add], [data-cyco-drawer-add], .quantity__number, [name="checkout"], .Vtl-CartDrawerProducts button, .Vtl-CartDrawerProducts input, .Vtl-CartDrawerCheckout button')];
    const disabled = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    button.textContent = button.dataset.applying;
    report('');
    let previousCodes = [], changed = false, success = false;
    try {
      const source = await read();
      if (Number(source.querySelector('[data-cyco-eligible-quantity]')?.dataset.cycoEligibleQuantity || 0) < 3) throw new Error(button.dataset.notReady);
      const beforeResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!beforeResponse.ok) throw new Error(button.dataset.error);
      const before = await beforeResponse.json();
      previousCodes = (before.discount_codes || []).filter(code => code.applicable).map(code => code.code);
      const mainId = document.querySelector('[data-section-type="cart"]')?.dataset.sectionId;
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: 'B2GOF', sections: mainId ? [sectionId, mainId] : [sectionId], sections_url: `${root}cart${previewId ? `?preview_theme_id=${previewId}` : ''}` })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(button.dataset.error);
      changed = true;
      let after = parse(data.sections?.[sectionId] || '').querySelector('[data-cyco-drawer-data]');
      if (!after) after = await read();
      if (Number(after.querySelector('[data-cyco-offer-savings]')?.dataset.cycoOfferSavings || 0) <= 0) throw new Error(button.dataset.error);
      success = true;
      if (mainId && data.sections?.[mainId]) {
        const page = parse(data.sections[mainId]);
        const current = document.querySelector('[data-section-type="cart"]');
        for (const selector of ['.cart-items', '.subtotal-row', '[data-cyco-offer-slot]', '[data-cyco-extras-slot]', '.cart-finish']) {
          const old = current?.querySelector(selector), next = page.querySelector(selector);
          if (old && next) old.innerHTML = next.innerHTML;
        }
      }
      if (openDrawer?.isConnected) render(openDrawer, after);
      document.dispatchEvent(new CustomEvent('vitals:cart-drawer:syncRequested'));
    } catch (error) {
      if (changed && !success && previousCodes.length) {
        try {
          await fetch(`${root}cart/update.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: previousCodes.join(',') }) });
          document.dispatchEvent(new CustomEvent('vitals:cart-drawer:syncRequested'));
        } catch {}
      }
      report(error.message === 'refresh' ? button.dataset.error : error.message);
    } finally {
      discountBusy = false;
      controls.forEach((control, i) => { if (control.isConnected) control.disabled = disabled[i]; });
      if (button.isConnected) button.textContent = oldLabel;
      if (success) { lastKey = ''; schedule(); }
    }
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => !record.target.closest?.('[data-cyco-drawer-slot], [data-cyco-drawer-offer]'))) schedule();
  });
  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-hidden', 'aria-busy'] });
    schedule();
  };
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start, { once: true });
})();

